export const EMPLOYEE_SERVICE_DATA = {
  COMMON_INFO: "commoninfo",
  LEAVE_APPLY_COMMON_INFO: "approval/commoninfo",
};
